// extracted by mini-css-extract-plugin
export default {"root":"StopTaskButton_root__Km8s5"};